import { useScrollReveal } from '../../hooks/useScrollReveal';

const reasons = [
  { title: 'Fully Insured, Private & Professional', desc: 'Your safety is our priority. All vehicles are insured, meticulously cleaned, and maintained with care. Our chauffeurs follow strict safety standards on every ride.' },
  { title: 'Founded by a Former Police Officer', desc: 'Willie Robinson brings years of law enforcement experience, professionalism, and work with three presidential campaigns to every single ride we provide.' },
  { title: 'True 24/7 Charleston Car Service', desc: 'Flights land at all hours. Events run late. Business meetings start early. We stay open around the clock so you always have a reliable luxury ride available.' },
  { title: 'Personalized Transportation for Every Need', desc: 'Airport rides, weddings, prom, corporate travel, private tours — whatever your plans look like, we drive according to your schedule, your pace, your needs.' },
  { title: 'Trusted for Privacy & Confidentiality', desc: 'We work with executives, public figures, and VIP clients who need low-profile transportation. Our chauffeurs protect your privacy from pickup to final drop-off.' },
  { title: 'Clean, Luxury Vehicles Every Time', desc: 'Vehicles are cleaned daily, maintained with care, and offer the comfort you expect from a premium luxury car service. No exceptions, no shortcuts.' },
  { title: 'Reliable Flight Tracking for Airport Transfers', desc: 'We monitor your flight in real-time and adjust pickup timing if your flight is early or delayed. When you land, your ride is always waiting — ready to go.' },
  { title: 'Professional Chauffeurs Trained for Excellence', desc: 'Our drivers complete ongoing training focused on safety, customer care, navigation, and delivering the luxury experience our clients deserve every time.' },
  { title: 'Expert Local Knowledge of Charleston', desc: 'We know the fastest routes, traffic patterns, back roads, and best drop-off points throughout Charleston, the Lowcountry, and all surrounding counties.' },
  { title: 'Honest, Transparent Pricing Always', desc: 'Request a free quote any time. We never add hidden fees or confusing surcharges — clear pricing, straightforward billing, honest communication from start to finish.' },
  { title: 'Group & Private Transportation Options', desc: 'From solo executive rides to wedding parties and corporate events, we handle both intimate and large group bookings with seamless coordination and precision.' },
  { title: 'Respectful, Friendly, Discreet Service', desc: 'Great transportation begins with how you\'re treated. Every client is greeted with respect, patience, and a genuine focus on your comfort and experience.' },
];

export default function PageWhyChoose() {
  const ref = useScrollReveal<HTMLDivElement>();

  return (
    <section className="bg-white py-28">
      <div className="max-w-7xl mx-auto px-6">
        <div ref={ref} className="section-reveal">
          <div className="grid lg:grid-cols-3 gap-10 mb-12 items-end">
            <div className="lg:col-span-2">
              <span className="text-gold text-xs tracking-widest uppercase font-semibold">Our Difference</span>
              <h2 className="font-display text-4xl md:text-5xl font-bold text-neutral-900 mt-3 leading-tight">
                Why Clients Choose<br />
                <span className="relative inline-block">
                  Tec&apos;s Limo Service
                  <span className="absolute bottom-0 left-0 w-full h-0.5 bg-gold"></span>
                </span>
              </h2>
              <p className="mt-6 text-neutral-500 text-sm leading-relaxed max-w-xl">
                Charleston&apos;s most trusted luxury transportation provider — chosen by locals, executives, tourists, and VIPs who expect the best in every detail.
              </p>
            </div>
            <div className="flex flex-col gap-3">
              <div className="flex items-center gap-3 bg-neutral-950 px-5 py-4">
                <div className="w-8 h-8 bg-gold flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-fill text-black text-sm"></i>
                </div>
                <div>
                  <div className="text-white/40 text-xs">Call Anytime, 24/7</div>
                  <a href="tel:+18436422440" className="text-white font-bold text-sm hover:text-gold transition-colors cursor-pointer">(843) 642-2440</a>
                </div>
              </div>
              <a href="#contact" className="block text-center bg-gold hover:bg-gold-light transition-colors text-black font-bold px-5 py-4 text-sm tracking-widest uppercase whitespace-nowrap cursor-pointer">
                Get a Free Quote
              </a>
            </div>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {reasons.map((reason, i) => (
              <div
                key={i}
                className="group flex gap-4 p-6 border border-neutral-100 hover:border-gold/30 hover:bg-neutral-50 transition-all duration-300"
              >
                <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center bg-gold/10 group-hover:bg-gold/20 transition-colors mt-0.5">
                  <i className="ri-check-line text-gold text-sm font-bold"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-neutral-900 text-sm mb-1.5 leading-snug group-hover:text-gold transition-colors">{reason.title}</h4>
                  <p className="text-neutral-500 text-xs leading-relaxed">{reason.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
